<template>
  <div>
    <h3 class="drawer-title" v-if="showTitle">
      Pand bewerken

      <a-button class="pull-right" v-on:click="onEditPropertyValuations">Waarderingen bewerken</a-button>
    </h3>
    <a-form :form="form" layout="vertical" @submit="handleSubmit">
      <a-row :gutter="16">
        <a-col :span="12">
          <div class="ant-col ant-form-item-label"><label title="Postcode">Postcode</label></div>
          <p>{{ property.postal_code }}</p>
        </a-col>
        <a-col :span="12">
          <div class="ant-col ant-form-item-label"><label title="Huisnummer">Huisnummer</label></div>
          <p>
            {{ property.formatted_number }}
          </p>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Straat">
            <a-input
                v-model="property.street"
                placeholder="Straat"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Woonplaats">
            <a-input
                v-model="property.city"
                placeholder="Woonplaats"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Gemeente">
            <a-input
                v-model="property.municipality"
                placeholder="Gemeente"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Provincie">
            <a-select
                v-model="property.province"
                placeholder="Provincie"
            >
              <a-select-option
                  :key="" value="">
                &nbsp;
              </a-select-option>
              <a-select-option v-for="province in provinces"
                               :key="province" :value="province">
                {{ province }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Land">
            <a-select
                v-model="property.country_id"
                v-on:change="onCountryChange"
                placeholder="Selecteer een land"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
            >
              <a-select-option v-for="country in countries" :key="country.id" :value="country.id">
                {{ country.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Soort">
            <a-select
                v-model="property.type"
                placeholder="Kies een soort"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
            >
              <a-select-option v-for="(typeName, type) in types" :key="type" :value="type">
                {{ typeName }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Verhuurtype">
            <a-select
                v-model="property.rental_type"
                placeholder="Selecteer een verhuurtype"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
            >
              <a-select-option v-for="(rentalTypeName, rentalType) in rentalTypes" :key="rentalType"
                               :value="rentalType">
                {{ rentalTypeName }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Onderpandtype">
            <a-select
                v-model="property.collateral_type"
                placeholder="Kies een onderpandtype"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
            >
              <a-select-option v-for="(collateralTypeName, collateralType) in collateralTypes"
                               :value="collateralType" :key="collateralType">
                {{ collateralTypeName }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16" v-if="isNew">
        <a-col :span="12">
          <a-form-item label="Bouwplannummer">
            <a-input
                v-model="property.construction_plan_number"
                placeholder="Bouwplannummer"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Situatienummer">
            <a-input
                v-model="property.situation_number"
                placeholder="Situatienummer"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Kadestrale aanduiding">
            <a-input
                v-model="property.cadastral_designation"
                placeholder="Kadestrale aanduiding"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Kadaster object id">
            <a-input
                v-model="property.cadastral_number"
                placeholder="Kadaster object id"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Status">
            <a-input
                v-model="property.purpose_status"
                placeholder="Status"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Gebruik">
            <a-input
                v-model="property.purpose"
                placeholder="Gebruik"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
      <a-form-item>
        <label>Gebruiksdoel
          <a-popover placement="top">
            <template slot="content">
              <span>Dit veld wordt automatisch gevuld bij een brondata sessie</span>
            </template>
            <information-outline-icon/>
          </a-popover>
        </label>
        <date-picker-component v-model="property.purpose"
                               :block="true"
                               :disabled="true"
        />
      </a-form-item>
        </a-col>
        <a-col :span="12">
      <a-form-item>
      <label>Gebruiksdoel status
        <a-popover placement="top">
          <template slot="content">
            <span>Dit veld wordt automatisch gevuld bij een brondata sessie</span>
          </template>
          <information-outline-icon/>
        </a-popover>
      </label>
      <date-picker-component v-model="property.status"
                             :block="true"
                             :disabled="true"
      />
    </a-form-item>
      </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Appartementstype">
            <a-input
                v-model="property.apartment_type"
                placeholder="Appartementstype"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Appartement subtype">
            <a-input
                v-model="property.apartment_sub_type"
                placeholder="Appartement subtype"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Huurinkomsten">
            <amount-input
                v-model="property.rental_income"
                placeholder="Huurinkomsten"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Heeft appartementsrecht">
            <a-radio-group
                button-style="solid"
                v-model="property.has_apartment_right">
              <a-radio-button :value="true">
                Ja
              </a-radio-button>
              <a-radio-button :value="false">
                Nee
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Bouwjaar">
            <year-input
                v-model="constructionYear"
                placeholder="Bouwjaar"
            >
            </year-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Perceel oppervlakte">
            <surface-input
                v-model="property.plot_size"
                placeholder="Perceel oppervlakte"
            >
            </surface-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Marktwaarde">
            <amount-input
                v-model="property.market_value"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Verkoopprijs">
            <amount-input
                v-model="property.sale_price"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Verkoopstatus">
            <a-input
                v-model="property.sale_status"
                placeholder="Verkoopstatus"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Staat te koop">
            <a-radio-group
                button-style="solid"
                v-model="property.for_sale">
              <a-radio-button :value="true">
                Ja
              </a-radio-button>
              <a-radio-button :value="false">
                Nee
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Verkocht">
            <a-radio-group
                button-style="solid"
                v-model="property.sold">
              <a-radio-button :value="true">
                Ja
              </a-radio-button>
              <a-radio-button :value="false">
                Nee
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Prijs">
            <amount-input
                v-model="property.price"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Prijs type">
            <a-input
                v-model="property.price_type"
                placeholder="Prijs type"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Prijs soort">
            <a-input
                v-model="property.price_kind"
                placeholder="Prijs soort"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Waarde Laag">
            <amount-input
                v-model="property.value_low"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Waarde hoog">
            <amount-input
                v-model="property.value_high"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Kwaliteit waarde">
            <a-input
                v-model="property.value_quality"
                placeholder="Kwaliteit waarde"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Koopsom">
            <amount-input
                v-model="property.purchase_price"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Originele schuld-marktwaarde verhouding">
            <percentage-input
                v-model="property.debt_market_value_ratio_original"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Afvalstoffenheffing">
            <amount-input
                v-model="property.waste_charges"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Rioolheffing">
            <amount-input
                v-model="property.sewage_charges"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Bouwjaar">
            <year-input
                v-model="constructionYear"
                placeholder="Bouwjaar"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Woning oppervlakte">
            <surface-input
                v-model="property.size"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Woning type">
            <a-input
                v-model="property.residential_building_type"
                placeholder="Woning type"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Woning subtype">
            <a-input
                v-model="property.residential_building_sub_type"
                placeholder="Woning subtype"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Label klasse">
            <a-input
                v-model="property.label_class"
                placeholder="Label klasse"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Label type">
            <a-input
                v-model="property.label_type"
                placeholder="Label type"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Prestatie index">
            <a-input
                type="number"
                v-model="property.performance_index"
                placeholder="Prestatie index"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Prestatie coëfficiënt">
            <a-input
                type="number"
                v-model="property.performance_coefficient"
                placeholder="Prestatie coëfficiënt"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Prestatie geldig tot">
            <date-picker-component :block="true"
                                   v-model="property.performance_valid_until"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Vastgoed waarde">
            <amount-input
                v-model="property.real_estate_value"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Energielabel">
            <a-select
                v-model="property.energy_label"
                placeholder="Energielabel"
            >
              <a-select-option
                  key="" value="">
                &nbsp;
              </a-select-option>
              <a-select-option v-for="(value, key) in energyLabels" :key="key" :value="key">
                {{ value }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Energielabel geldig tot">
            <date-picker-component :block="true"
                                   v-model="property.energy_label_end_date"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Stroom normaal">
            <energy-input typee="number" :block="true"
                          v-model="property.electricity_normal"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Stroom dal">
            <energy-input typee="number" :block="true"
                          v-model="property.electricity_low"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Dubbele of slimme meter">
            <a-radio-group
                button-style="solid"
                v-model="property.double_or_smart_meter">
              <a-radio-button :value="true">
                Ja
              </a-radio-button>
              <a-radio-button :value="false">
                Nee
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Zonnepanelen">
            <a-radio-group
                button-style="solid"
                v-model="property.solar_panels">
              <a-radio-button :value="true">
                Ja
              </a-radio-button>
              <a-radio-button :value="false">
                Nee
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16" v-if="property.solar_panels">
        <a-col :span="12">
          <a-form-item label="Stroomopwekking normaal">
            <energy-input typee="number" :block="true"
                          v-model="property.electricity_generated_normal"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Stroomopwekking dal">
            <energy-input typee="number" :block="true"
                          v-model="property.electricity_generated_low"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Gasverbruik">
            <volume-input typee="number" :block="true"
                          v-model="property.gas"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="Is erfpacht">
            <a-radio-group
                button-style="solid"
                v-model="property.is_leasehold">
              <a-radio-button :value="true">
                Ja
              </a-radio-button>
              <a-radio-button :value="false">
                Nee
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="12" v-if="property.is_leasehold">
          <a-form-item label="Is erfpacht eeuwigdurend">
            <a-radio-group
                button-style="solid"
                v-model="property.is_leasehold_forever">
              <a-radio-button :value="true">
                Ja
              </a-radio-button>
              <a-radio-button :value="false">
                Nee
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16" v-if="property.is_leasehold">
        <a-col :span="12">
          <a-form-item label="Erfpacht startdatum">
            <date-picker-component :block="true"
                                   v-model="property.leasehold_start_date"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12" v-if="!property.is_leasehold_forever">
          <a-form-item label="Erfpacht einddatum">
            <date-picker-component :block="true"
                                   v-model="property.leasehold_end_date"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16" v-if="property.is_leasehold">
        <a-col :span="12">
          <a-form-item label="Is erfpachtcanon">
            <a-radio-group
                button-style="solid"
                v-model="property.is_leasehold_canon">
              <a-radio-button :value="true">
                Ja
              </a-radio-button>
              <a-radio-button :value="false">
                Nee
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="12" v-if="property.is_leasehold_canon">
          <a-form-item label="Erfpachtcanon">
            <amount-input
                v-model="property.leasehold_canon"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16" v-if="property.is_leasehold_canon">
        <a-col :span="12">
          <a-form-item label="Erfpachtcanon in verleden afgekocht">
            <a-radio-group
                button-style="solid"
                v-model="property.is_leasehold_canon_bought_off_in_past">
              <a-radio-button :value="true">
                Ja
              </a-radio-button>
              <a-radio-button :value="false">
                Nee
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Erfpachtcanon eeuwig durend afgekocht">
            <a-radio-group
                button-style="solid"
                v-model="property.is_leasehold_canon_bought_off_forever">
              <a-radio-button :value="true">
                Ja
              </a-radio-button>
              <a-radio-button :value="false">
                Nee
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16" v-if="property.is_leasehold_canon">
        <a-col :span="12">
          <a-form-item label="Erfpachtcanon afgekocht tot">
            <date-picker-component :block="true"
                                   v-model="property.leasehold_canon_bought_off_until_date"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import countriesApi from '~/api/country';

const moment = require('moment');

export default {
  name: "PropertyEditComponent",
  components: {},
  props: {
    property: {
      type: Object,
      required: true,
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      countries: [],
      form: this.$form.createForm(this),
      visible: false,
      types: {
        single_family_home: 'Eengezinswoning',
        single_family_house_with_garage: 'Eengezinswoning met garage',
        flat_apartment: 'Flat/appartement',
        flat_apartment_with_garage: 'Flat/appartement met garage',
        shop_house: 'Winkel-woonhuis',
        residential_house_with_commercial_space: 'Woonhuis met bedrijfsruimte',
        store: 'Winkel',
        business_premises: 'Bedrijfspand',
        recreational_home: 'Recreatiewoning',
        farm: 'Boerderij',
        business_collateral: 'Zakelijk onderpand',
        agricultural_building_land: 'Agrarische grond/bouwgrond',
        garage: 'Garage',
        building_plot: 'Bouwkavel',
        houseboat: 'Woonschip',
        pleasure_craft: 'Pleziervaartuig',
      },
      rentalTypes: {
        no_rental: 'geen verhuur',
        temporary_rental: 'tijdelijke verhuur',
        partial_temporary_rental: 'gedeeltelijke tijdelijke verhuur (kamer, etage)',
        partial_rental: 'gedeeltelijke verhuur (kamer, etage)',
        permanent_rental: 'permanente verhuur',
      },
      collateralTypes: {
        existing: 'bestaand',
        existing_renovation: 'bestaand verbouw',
        new: 'nieuw',
      },
      energyLabels: {
        EnergieNeutraal: 'EnergieNeutraal',
        NulOpDeMeter: 'NulOpDeMeter',
        APlusPlusPlusPlus: 'A++++',
        APlusPlusPlus: 'A+++',
        APlusPlus: 'A++',
        APlus: 'A+',
        A: 'A',
        B: 'B',
        C: 'C',
        D: 'D',
        E: 'E',
        F: 'F',
        G: 'G',
      },
      provinces: [
        'Drenthe',
        'Friesland',
        'Flevoland',
        'Gelderland',
        'Groningen',
        'Limburg',
        'Noord-Brabant',
        'Noord-Holland',
        'Overijssel',
        'Utrecht',
        'Zeeland',
        'Zuid-Holland'
      ],
      isNewProxy: null
    };
  },
  computed: {
    constructionYear: {
      get: function () {
        return moment(this.property.construction_year || moment().format('YYYY'), 'YYYY');
      },
      set: function (value) {
        this.property.construction_year = value.format('YYYY');
      }
    },
    isNew() {
      if (this.property && typeof this.property !== 'undefined' && this.property.collateral_type !== this.isNewProxy) {
        this.isNewProxy = this.property.collateral_type === "new";
      }
      return this.isNewProxy
    },
  },
  mounted() {
    countriesApi.all().then(response => {
      this.countries = response.data;
    })
  },
  methods: {
    handleSubmit() {

    },
    handleChangePropertyCollateralType(value) {
      this.$set(this.property, 'collateral_type', value);
    },
    onEditPropertyValuations() {
      this.$refs.editValuationsDrawer.visible = true;
    },
    onCountryChange() {
      this.$set(this.property, 'country', {
        data: this.countries.find(country => country.id === this.property.country_id)
      });
    },
    filterOption(input, option) {
      return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>
<style scoped>
.drawer-title {
  margin-bottom: 30px;
}

.pull-right {
  float: right;
}
</style>